import { render } from "./spinner-loading.vue?vue&type=template&id=b1667f3e&scoped=true"
const script = {}

import "./spinner-loading.vue?vue&type=style&index=0&id=b1667f3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1667f3e"]])

export default __exports__